/* Template: Example function
 ========================================================================== */

template.mobile_menu = () => {
    'use strict';

    const $menu_toggle = $('.menu-toggle'),
        $site_navigation = $('#site-navigation'),
        $menu_title = $('.menu-label'),
        $has_children = $('.page_item_has_children > a, .menu-item-has-children > a'),
        $site_header = $('.site-header_main'),
        $menu_title_text = 'Menu',
        $menu_title_text_close = 'Close',
        $supports_touch = 'ontouchstart' in window || navigator.msMaxTouchPoints;

    let mq = template.media_query();

    $menu_toggle.click(function() {
        $site_navigation.toggleClass('open');
        $menu_toggle.toggleClass('open');

        if ($site_navigation.hasClass('open')) {
            $menu_title.html($menu_title_text_close);
        } else {
            $menu_title.html($menu_title_text);
        }

    });

    $has_children.click(function(e) {

        const $this = $(this);

            // if its a touch device (mobile, tablet) or mobile media query
        if ($supports_touch || ['xs','sm','md'].indexOf(mq) !== -1) {
            // if it's child menu is not open, open it
            if (!$this.parent().hasClass('open')) {
                e.preventDefault();
                $has_children.each(function() {
                   $(this).parent().removeClass('open');
                });
                $this.parent().addClass('open');
            }
            // otherwise just fire the link
        }

    });

};
